export default [

     {
          path: '/deliverable',
          name: 'Deliverable',
          component: () => import("@/views/Page/StrategicPlan/Deliverable/Deliverable.vue"),
           meta: {
               title: 'Deliverable',
          },
     }
];